<mat-list>
  <ng-container *ngFor="let item of serverFiles; let i = index">
    <mat-list-item>
      <span class="filename"><mat-icon>file_copy</mat-icon>{{ item.fileName }}</span>

      <div class="d-flex file-actions">
        <button
          class="action-button mr-2"
          mat-raised-button
          color="primary"
          [disabled]="item.isDeleting"
          (click)="download(item.id)"
        >
          <mat-icon>get_app</mat-icon>{{ 'Common.Download' | translate }}
        </button>
        <button
          class="action-button width-120"
          mat-raised-button
          color="warn"
          [disabled]="item.canDelete !== true || item.isDeleting"
          (click)="removeServer(item.id)"
        >
          <mat-icon>delete</mat-icon>{{ 'Common.Delete' | translate }}
        </button>
      </div>
    </mat-list-item>
    <mat-divider></mat-divider>
  </ng-container>

  <ng-container *ngFor="let item of files; let i = index">
    <mat-list-item>
      <span class="filename"><mat-icon>file_copy</mat-icon>{{ item.file.name }}</span>

      <div class="d-flex file-actions">
        <ng-container *ngIf="item.error">
          <span class="color-red">{{ 'Errors.WhileSendingFile' | translate }}</span>
          <button mat-button color="warn" (click)="removeLocal(item.id)"><mat-icon>close</mat-icon></button>
        </ng-container>
        <ng-container *ngIf="item.finished">
          <button
            class="action-button mr-2"
            mat-raised-button
            color="primary"
            [disabled]="item.isDeleting"
            (click)="download(item.id)"
          >
            <mat-icon>get_app</mat-icon>{{ 'Common.Download' | translate }}
          </button>
          <button class="action-button" mat-raised-button color="warn" (click)="removeFile(item.id)">
            <mat-icon>delete</mat-icon>{{ 'Common.Delete' | translate }}
          </button>
        </ng-container>
      </div>
    </mat-list-item>
    <mat-progress-bar
      *ngIf="!item.finished"
      [color]="item.error ? 'warn' : undefined"
      mode="determinate"
      [value]="item.progress"
    ></mat-progress-bar>
    <mat-divider></mat-divider>
  </ng-container>
</mat-list>

<div class="d-flex p-40" (drop)="onDrop($event)" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)">
  <div
    [ngClass]="{
      'files-drop': true,
      'drop-text-parent': true,
      'dashed-container': dragOverStatus !== 'drag-over',
      'dragged-over': dragOverStatus === 'drag-over'
    }"
  >
    <div class="drop-text">
      <span>{{ 'Common.DropHere' | translate }}</span>
    </div>
  </div>
  <div class="relative mb-6">
    <button class="relative-bottom action-button" mat-raised-button color="primary" (click)="fileInput.click()">
      <span>{{ 'Common.AddFiles' | translate }}</span>
      <input
        #fileInput
        type="file"
        multiple
        (change)="addFiles(fileInput.files); fileInput.value = null"
        style="display: none;"
      />
    </button>
  </div>
</div>
